import { alpha, Box, styled } from "@mui/material";

export const OptionCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  flex: "1 1 280px",
  maxWidth: 400,
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${isSelected ? theme.palette.primary.main : theme.palette.divider}`,
  backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.04) : "transparent",
  ...(!isSelected && {
    cursor: "pointer",
    "&:hover": { backgroundColor: theme.palette.action.hover },
  }),
}));

export const OptionIcon = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  "& svg": {
    display: "block",
    width: "100%",
    height: "auto",
  },
}));

// Both descriptions share a grid cell so toggling the option doesn't change the card's height.
export const OptionDescriptions = styled(Box)({
  display: "grid",
});
